import { render, staticRenderFns } from "./changeRecord.vue?vue&type=template&id=c93a6a3e&scoped=true&"
import script from "./changeRecord.vue?vue&type=script&lang=js&"
export * from "./changeRecord.vue?vue&type=script&lang=js&"
import style0 from "./changeRecord.vue?vue&type=style&index=0&id=c93a6a3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93a6a3e",
  null
  
)

export default component.exports